import Vue from 'vue'
import Router from 'vue-router'
import index from '@/components/index'
import paidCourses from '@/components/paidCourses'
import freeCourses from '@/components/freeCourses'
import teachingMaterial from '@/components/teachingMaterial'
import studyAbroad from '@/components/studyAbroad'
import cleanExpert from '@/components/cleanExpert'
import coursesIndex from '@/components/coursesIndex'
import shareCourses from '@/components/shareCourses'
import expertOpinion from '@/components/expertOpinion'
import investment from '@/components/investment'
import aboutUs from '@/components/aboutUs'
import organizationDetails from '@/components/organizationDetails'
import newsDetails from '@/components/newsDetails'
import attractInvestment from '@/components/attractInvestment'




Vue.use(Router)

export default new Router({
    mode:'history',
  routes: [
    {
      path: '/',
      name: 'index',
      component: index   //首页
    },
    {
      path: '/paidCourses/:id',
      name: 'paidCourses',
      component: paidCourses  //付费课程
    },
    {
      path: '/freeCourses/:id',
      name: 'freeCourses',
      component: freeCourses  //免费课程
    },
    {
      path: '/teachingMaterial/:id',
      name: 'teachingMaterial',
      component: teachingMaterial  //教材
    },
    {
      path: '/studyAbroad',
      name: 'studyAbroad',
      component: studyAbroad  //国外游学
    },
    {
      path: '/cleanExpert',
      name: 'cleanExpert',
      component: cleanExpert  //清洁专家
    },
    {
      path: '/coursesIndex',
      name: 'coursesIndex',
      component: coursesIndex  //课程首页
    },
    {
      path: '/shareCourses',
      name: 'shareCourses',
      component: shareCourses  //分享课程
    },
    {
      path: '/expertOpinion/:id',
      name: 'expertOpinion',
      component: expertOpinion  //专家观点
    },
    {
      path: '/investment',
      name: 'investment',
      component: investment  //招商合作
    },
    {
      path: '/aboutUs',
      name: 'aboutUs',
      component: aboutUs  //关于我们
    },
    {
      path: '/organizationDetails',
      name: 'organizationDetails',
      component: organizationDetails  //合作组织详情页
    },
  {
      path: '/newsDetails',
      name: 'newsDetails',
      component: newsDetails  //新闻详情
    },
  {
      path: '/attractInvestment',
      name: 'attractInvestment',
      component: attractInvestment  //招商合作
    },




  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js